class ScoreggiaHeaderWordmarkBounds {
  constructor(header) {
    this.header = header;
    this.update = this.update.bind(this);
  }

  connect() {
    this.home = this.header.querySelector(':scope > .scoreggia-header-home');
    this.icons = this.header.querySelector(':scope > .header__icons');
    if (!this.home || !this.icons) return;

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.header);
      this.resizeObserver.observe(this.home);
      this.resizeObserver.observe(this.icons);
    }

    window.addEventListener('resize', this.update, { passive: true });
    this.update();
  }

  disconnect() {
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.update);
    window.cancelAnimationFrame(this.updateFrame);
  }

  update() {
    window.cancelAnimationFrame(this.updateFrame);
    this.updateFrame = window.requestAnimationFrame(() => {
      const headerBounds = this.header.getBoundingClientRect();
      const homeBounds = this.home.getBoundingClientRect();
      const iconBounds = this.icons.getBoundingClientRect();
      const leftReserve = Math.max(0, homeBounds.right - headerBounds.left);
      const rightReserve = Math.max(0, headerBounds.right - iconBounds.left);
      const viewportExcess = Math.max(0, window.innerWidth - headerBounds.width);
      const symmetricReserve = Math.ceil(Math.max(leftReserve, rightReserve) + 12 + viewportExcess / 2);

      this.header.style.setProperty('--scoreggia-header-side-reserve', `${symmetricReserve}px`);
    });
  }
}

const scoreggiaHeaderBoundsInstances = new WeakMap();

function initializeScoreggiaHeaderBounds(container) {
  const headers = [];
  if (container.matches?.('.scoreggia-header--reference')) headers.push(container);
  headers.push(...container.querySelectorAll?.('.scoreggia-header--reference') || []);

  headers.forEach((header) => {
    if (scoreggiaHeaderBoundsInstances.has(header)) return;
    const instance = new ScoreggiaHeaderWordmarkBounds(header);
    scoreggiaHeaderBoundsInstances.set(header, instance);
    instance.connect();
  });
}

document.addEventListener('DOMContentLoaded', () => initializeScoreggiaHeaderBounds(document));

document.addEventListener('shopify:section:load', (event) => {
  initializeScoreggiaHeaderBounds(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  const header = event.target.matches?.('.scoreggia-header--reference')
    ? event.target
    : event.target.querySelector?.('.scoreggia-header--reference');
  const instance = header && scoreggiaHeaderBoundsInstances.get(header);
  if (!instance) return;
  instance.disconnect();
  scoreggiaHeaderBoundsInstances.delete(header);
});
